export enum TransferFileAction {
    Download = 1,
    Send = 2,
    CreateAndSend = 3,
    Delete = 4,
    Share = 5
}